import React, { useEffect } from 'react';

// This component's only job is to make sure unassigned jobs get loaded
export default function AutoLoader({ 
  unassignedJobs = [],
  totalUnassignedCount = 0,
  isLoading = false,
  hasMore = false,
  loadJobs = () => {}
}) {
  // Force loading on mount and when dependencies change
  useEffect(() => {
    if (totalUnassignedCount > 0 && 
        unassignedJobs.length === 0 && 
        !isLoading && 
        hasMore) {
      
      // Small delay to avoid React state update conflicts
      const timer = setTimeout(() => {
        loadJobs();
      }, 50);
      
      return () => clearTimeout(timer);
    }
  }, [unassignedJobs.length, totalUnassignedCount, isLoading, hasMore, loadJobs]);

  // This component doesn't render anything visible
  return null;
} 